// Where the bare "/" route sends somebody.
//
// The order here is the whole point. A link somebody just tapped beats the crew
// they happened to be in last, every time.
//
// It did not used to. Claiming only covered email invites, so a crew link held
// by someone who was already in a crew fell through to "open the crew you used
// last" and the join never happened: they landed back in their old crew and no
// membership was ever created for the new one. The person tapped a link, the
// app opened, and nothing about it acknowledged the link at all.

export interface LandingInput {
  /** A crew just joined by claiming an email invite, if any. */
  claimedLeagueId: string | null;
  /** A link they tapped that has not been redeemed yet. */
  pendingToken: string | null;
  /** Crews they are already a joined member of. */
  crewIds: string[];
  /** Where they were last time. */
  rememberedId: string | null;
}

export type LandingTarget =
  | { kind: "onboarding"; leagueId: string }
  | { kind: "redeem"; token: string }
  | { kind: "crew"; leagueId: string }
  | { kind: "empty" };

export function landingTarget(input: LandingInput): LandingTarget {
  // Just claimed an emailed invite: that crew, with the welcome, because being
  // new to a crew is the thing that most needs explaining.
  if (input.claimedLeagueId) return { kind: "onboarding", leagueId: input.claimedLeagueId };

  // An unredeemed link outranks the remembered crew. This is the fix: being in
  // a crew already must not swallow the link to a different one.
  if (input.pendingToken) return { kind: "redeem", token: input.pendingToken };

  const remembered = input.rememberedId && input.crewIds.includes(input.rememberedId)
    ? input.rememberedId
    : null;
  const open = remembered ?? input.crewIds[0] ?? null;
  return open ? { kind: "crew", leagueId: open } : { kind: "empty" };
}
